import { ENDPOINTS } from '../utils/endpoints';
import { getAPIwithToken, postAPIwithToken, patchAPIwithToken } from '../utils/fetchApi';

export interface ApiITCa {
  id: number;
  name: string;
  description?: string;
  status: number | string | boolean;
  is_active?: number;
  createdBy?: string;
  created_by?: string;
  createdOn?: string;
  createdAt?: string;
  created_at?: string;
  updatedAt?: string;
  updated_at?: string;
}

export interface GetITCaResponse {
  success?: boolean;
  status?: string | number;
  message?: string;
  data?: ApiITCa[];
  itca?: ApiITCa[];
  records?: ApiITCa[];
}

export interface CreateITCaPayload {
  name: string;
  description?: string;
  status?: number;
}

export interface UpdateITCaPayload {
  id: number;
  name?: string;
  description?: string;
  status?: number;
}

export async function getITCaList(): Promise<GetITCaResponse> {
  return getAPIwithToken<GetITCaResponse>(ENDPOINTS.ITCA);
}

export async function createITCa(
  payload: CreateITCaPayload
): Promise<any> {
  return postAPIwithToken(ENDPOINTS.ITCA, payload);
}

export async function updateITCa(
  payload: UpdateITCaPayload
): Promise<any> {
  return patchAPIwithToken(ENDPOINTS.ITCA, payload);
}
